import React, { useState, useEffect } from 'react';
import './Estado_verificacion.css';

const EstadoVerificacion = () => {
  const [tickets, setTickets] = useState([]); // Lista de tickets disponibles
  const [ticketSeleccionado, setTicketSeleccionado] = useState('');
  const [datosVerificacion, setDatosVerificacion] = useState({
    ticket: '',
    fechaIngreso: '',
    fechaResolucion: '',
    estado: '',
    diasRestantes: ''
  });
  useEffect(() => {
    cargarTickets();
  }, []);

const cargarTickets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ESTADO_VERIFICACION_URL}/get_tickets_aprobados.php`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );
      const data = await response.json();

      if (data.success) {
        setTickets(data.data);
      } else {
        console.error('Error al cargar tickets:', data.message);
        setTickets([]);
      }
    } catch (error) {
      console.error('Error al cargar tickets:', error);
      setTickets([]);
    }
  };

const buscarVerificacion = async () => {
    if (!ticketSeleccionado) {
      alert('Por favor selecciona un ticket');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_ESTADO_VERIFICACION_URL}/get_verificaciones.php`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );
      const data = await response.json();

      if (data.success) {
        // Filtrar por el ticket seleccionado en el dropdown
        const registro = data.data.find(
          (item) => item.ticket_est_public === ticketSeleccionado
        );

        if (registro) {
          setDatosVerificacion({
            ticket:          registro.ticket_est_public,
            fechaIngreso:    registro.fecha_ingreso,
            fechaResolucion: registro.fecha_resolucion,
            estado:          registro.estado,
            diasRestantes:   registro.proceso_pago_d_h
          });
        } else {
          alert('No se encontró información para este ticket');
        }
      } else {
        alert('Error: ' + data.message);
      }
    } catch (error) {
      console.error('Error al buscar verificación:', error);
      alert('Error al buscar la verificación');
    }
  };


return (
    <>
      <div className="estado-publicaciones-container">
      <div className="estado-publicaciones-content">
        <h1 className="estado-titulo">ESTADO DE TUS VERIFICACIONES :</h1>
        <hr className="estado-linea" />
        
        <div className="estado-texto-info">
          <p className="texto-normal">
            Puedes verificar mediante el N° de ticket el estado de tus verificaciones.
          </p>
          
          <p className="texto-normal">
            <span className="texto-rojo">NOTA IMPORTANTE :</span> una vez el estado del ticket cambie a <span className="texto-rojo">APROBADO</span>, se te notificara y tienes 3 dias, para realizar el siguiente proceso que es de <span className="texto-rojo">PAGO</span>, en caso que el proceso venza, tendras que nuevamente realizar el proceso completo desde el comienzo, <span className="texto-rojo">PUBLICAR TU AVISO</span>, posteriormente realizar el proceso de <span className="texto-rojo">VERIFICACION</span>
          </p>
        </div>

        <div className="estado-formulario-container">
          <div className="campo-grupo">
            <label className="campo-label">N° de ticket :</label>
            <div className="campo-input-grupo">
              <select 
                className="campo-select"
                value={ticketSeleccionado}
                onChange={(e) => setTicketSeleccionado(e.target.value)}
              >
                <option value="">Seleccione un ticket</option>
{tickets.map((item, index) => (
  <option key={index} value={item.ticket}>
    {item.ticket} — {item.nombre_publicacion}
  </option>
))}
              </select>
              <button className="btn-buscar" onClick={buscarVerificacion}>BUSCAR</button>
            </div>
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Fecha - Ingreso Verificacion :</label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosVerificacion.fechaIngreso} 
              readOnly 
            />
          </div>

          <div className="campo-grupo">
            <label className="campo-label">Fecha - Resolucion :</label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosVerificacion.fechaResolucion} 
              readOnly 
            />
          </div>

<div className="campo-grupo">
  <label className="campo-label">Estado :</label>
  <div style={{
    padding: '8px 12px',
    border: '2px solid #000',
    maxWidth: '400px',
    width: '100%',
    backgroundColor: datosVerificacion.estado === 'Pendiente' ? '#FFA500'
                   : datosVerificacion.estado === 'Aprobada'  ? '#008000'
                   : datosVerificacion.estado === 'Rechazada' ? '#FF0000'
                   : '#ffffff',
    color: datosVerificacion.estado ? '#ffffff' : '#000000',
    fontFamily: "'Arial Black', Arial, sans-serif",
    fontSize: '16px',
    fontWeight: '900',
    minHeight: '38px',
    display: 'flex',
    alignItems: 'center'
  }}>
    {datosVerificacion.estado || ''}
  </div>
</div>

          <div className="campo-grupo">
            <label className="campo-label">Dias - Horas restantes<br />para PROCESO DE PAGO :</label>
            <input 
              type="text" 
              className="campo-input" 
              value={datosVerificacion.diasRestantes} 
              readOnly 
            />
          </div>
        </div>

        <div className="estado-informativo">
          <p className="texto-informativo">Informativo :</p>
        </div>
</div>
    </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default EstadoVerificacion;